import type { PaymentPricing } from '@/types/payment-account';

import { PAYMENT_FEES } from '../facts';

/**
 * Tabela de reserva do recebimento pelo link, montada de `PAYMENT_FEES`
 * (`content/facts.ts`). A central pública (`/ajuda/recebimentos`) renderiza
 * com ela no HTML estático e troca pelos números vivos de
 * `GET /payment-account/pricing/public` quando a API responde.
 */
export const FALLBACK_PUBLIC_PRICING: PaymentPricing = {
  enabled: true,
  canActivate: false,
  fee: {
    pixPercent: PAYMENT_FEES.pixPercent,
    cardPercent: PAYMENT_FEES.cardPercent,
    cardFixed: PAYMENT_FEES.cardFixed,
    boletoFixed: PAYMENT_FEES.boletoFixed,
  },
  marginPercent: PAYMENT_FEES.marginPercent,
  pixMin: PAYMENT_FEES.pixMin,
  pixMax: PAYMENT_FEES.pixMax,
  boletoMin: PAYMENT_FEES.boletoMin,
  boletoMax: PAYMENT_FEES.boletoMax,
  cardBrands: PAYMENT_FEES.cardBrands.map((brand) => brand.toLowerCase()),
  settlement: {
    cardDays: PAYMENT_FEES.cardSettlementDays,
    pixBusinessDays: PAYMENT_FEES.pixSettlementBusinessDays,
  },
  // Igual a `PAYMENTS_TERMS_VERSION` (`components/legal/payments-terms-section.tsx`).
  termsVersion: '2026-09-22',
};
